import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "지원 정책",
  "description": "Turborepo의 지원 정책에 대해 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "패키지-관리자",
    "content": "핵심 turbo 기능은 JavaScript 생태계의 패키지 관리자와 해당 Workspace 및 lockfile 형식 구현에 의존합니다."
  }, {
    "heading": "패키지-관리자",
    "content": "패키지 관리자"
  }, {
    "heading": "패키지-관리자",
    "content": "지원 여부"
  }, {
    "heading": "패키지-관리자",
    "content": "pnpm 8+"
  }, {
    "heading": "패키지-관리자",
    "content": "예"
  }, {
    "heading": "패키지-관리자",
    "content": "npm 8+"
  }, {
    "heading": "패키지-관리자",
    "content": "예"
  }, {
    "heading": "패키지-관리자",
    "content": "yarn 1+"
  }, {
    "heading": "패키지-관리자",
    "content": "예 (Yarn Plug'n'Play 포함)"
  }, {
    "heading": "패키지-관리자",
    "content": "bun 1.2+"
  }, {
    "heading": "패키지-관리자",
    "content": "Beta"
  }, {
    "heading": "패키지-관리자",
    "content": "패키지 관리자는 자체 릴리스 일정, 버그 및 기능을 가지고 있습니다. 새로운 주요\n버전을 따라가려고 노력하지만 즉시 지원을 릴리스하지 못할 가능성이 높습니다."
  }, {
    "heading": "플랫폼",
    "content": "turbo는 일반적으로 Debian 기반 Linux 배포판, macOS 및 Windows에서 x86_64 및 ARM 64 아키텍처 모두에서 지원됩니다. 구체적으로, npm을 통해 다음 바이너리를 빌드하고 제공합니다:"
  }, {
    "heading": "플랫폼",
    "content": "turbo-darwin-64 (Intel 칩을 사용하는 macOS)"
  }, {
    "heading": "플랫폼",
    "content": "turbo-darwin-arm64 (Apple Silicon을 사용하는 macOS)"
  }, {
    "heading": "플랫폼",
    "content": "turbo-linux-64"
  }, {
    "heading": "플랫폼",
    "content": "turbo-linux-arm64"
  }, {
    "heading": "플랫폼",
    "content": "turbo-windows-64*"
  }, {
    "heading": "플랫폼",
    "content": "turbo-windows-arm64*"
  }, {
    "heading": "플랫폼",
    "content": "*: Windows C Runtime\nLibraries\n필요"
  }, {
    "heading": "nodejs",
    "content": "핵심 turbo 기능은 시스템의 활성 Node.js 버전에 의존하지 않지만, create-turbo, turbo-ignore 및 eslint-config-turbo와 같은 Turborepo 생태계의 일부 패키지는 의존합니다. 이러한 기능의 경우 Node.js의 Active 및 Maintenance LTS 버전을 지원할 예정입니다."
  }, {
    "heading": "nodejs",
    "content": "Turborepo의 예제도 이러한 Node.js 버전에서 작동할 것으로 예상됩니다."
  }, {
    "heading": "버전-관리",
    "content": "Git으로 버전 관리되는 리포지토리와 버전 관리가 전혀 없는 리포지토리를 지원합니다. 다른 버전 관리 시스템은 무시됩니다."
  }, {
    "heading": "버전-관리",
    "content": "파일 해싱에 Git을 사용하므로 git이 없는 리포지토리는 다르게 수행되고 동작할 수 있습니다."
  }, {
    "heading": "lts-정책",
    "content": "Turborepo의 주요 버전은 다음 주요 버전의 릴리스 날짜로부터 2년 동안 지원됩니다."
  }, {
    "heading": "lts-정책",
    "content": "이전 버전의 중요한 보안 수정에 필요한 변경 사항은 백포트됩니다. 이러한 상황은 드물며 중대한 변경 사항이더라도 semver-minor 릴리스로 제공됩니다."
  }, {
    "heading": "lts-정책",
    "content": "가능한 한 최신 버전의 Turborepo를 사용하실 것을 강력히 권장합니다."
  }, {
    "heading": "lts-정책",
    "content": "주요 버전"
  }, {
    "heading": "lts-정책",
    "content": "릴리스 날짜"
  }, {
    "heading": "lts-정책",
    "content": "지원 종료 날짜"
  }, {
    "heading": "lts-정책",
    "content": "2.x"
  }, {
    "heading": "lts-정책",
    "content": "2024년 6월 4일"
  }, {
    "heading": "lts-정책",
    "content": "1.x"
  }, {
    "heading": "lts-정책",
    "content": "2021년 12월 9일"
  }, {
    "heading": "lts-정책",
    "content": "2026년 6월 4일"
  }, {
    "heading": "릴리스-단계",
    "content": "Turborepo의 안정 빌드는 시맨틱 버저닝(semver)을 따르며 릴리스되기 전에 철저하게 테스트됩니다."
  }, {
    "heading": "릴리스-단계",
    "content": "Turborepo는 또한 개발의 초기 단계에서 릴리스될 수 있는 특정 API를 제공합니다. 이는 얼리 어답터가 귀중한 피드백을 제공하고 핵심 팀이 안정적인 릴리스 전에 API에 대한 확신을 얻을 수 있도록 하기 위한 것입니다. 사전 안정 버전으로 제공되는 API는 가능한 한 문서와 turbo 자체에서 그렇게 표시됩니다."
  }, {
    "heading": "릴리스-단계",
    "content": "모든 API가 모든 단계에서 릴리스되는 것은 아닙니다. 기능의 복잡성, 가능한 사용 사례 및 API의 초기 사용자로부터의 피드백과 같은 요소를 고려하여 기능에 대한 확신을 바탕으로 API의 단계를 결정하기 위해 최선의 판단을 사용합니다."
  }, {
    "heading": "릴리스-단계",
    "content": "Turborepo 핵심 팀은 기능을 조기에 사용하는 모든 사용자에게 감사드리며 제공해주시는 모든 피드백에 대해 감사를 표합니다."
  }, {
    "heading": "stable",
    "content": "API가 안정성에 도달하면 프로덕션에서 사용할 준비가 된 것으로 간주됩니다. 안정 버전으로 표시된 API는 주요 릴리스에서만 하위 호환되는 방식으로 변경됩니다."
  }, {
    "heading": "stable",
    "content": "안정적인 API가 향후 주요 릴리스에서 중대한 변경 사항을 가질 예정인 경우, 마이그레이션 및 다음 단계를 돕기 위한 경고 및 문서가 제공됩니다."
  }, {
    "heading": "stable",
    "content": "안정적인 API가 향후 주요 릴리스에서 제거될 예정인 경우, 향후 제거에 대한 조기 통지를 제공하기 위해 Deprecated로 표시됩니다."
  }, {
    "heading": "beta",
    "content": "Beta API는 안정적인 릴리스 전에 신뢰성에 대한 더 많은 확신이 필요합니다. Beta 단계에서는 기능의 전체 디자인에 대해 확신하고 있으며 상대적으로 적은 변경으로 기능을 안정 버전으로 승격할 수 있을 것으로 예상합니다. 드문 경우지만 API가 중대한 변경을 필요로 할 수 있으며 semver의 적용을 받지 않습니다."
  }, {
    "heading": "beta",
    "content": "얼리 어답터가 Beta API를 사용하여 기능의 디자인과 안정성에 대한 확신을 얻도록 권장합니다. 위험 허용 범위에 따라 적절하게 프로덕션에서 기능을 사용할 수 있습니다."
  }, {
    "heading": "beta",
    "content": "현재 Beta 단계에 있는 API:"
  }, {
    "heading": "beta",
    "content": "없음"
  }, {
    "heading": "experimental",
    "content": "Experimental API는 안정성을 위해 필요한 필수 기능이 부족합니다. 기능의 디자인은 활발하게 개발 중인 것으로 간주되며 언제든지 변경될 수 있습니다."
  }, {
    "heading": "experimental",
    "content": "안정성이 필수적이지 않은 사이드 프로젝트, 개념 증명 및 기타 환경에서 Experimental API를 테스트하는 데 도움을 주시길 권장합니다. 이를 통해 기능이 개발되는 동안 핵심 팀에 조기 피드백을 제공함으로써 API 개발을 지원할 수 있는 기회를 얻을 수 있습니다. 신뢰성이 필수적인 곳에서는 Experimental API를 사용하지 않는 것이 좋습니다."
  }, {
    "heading": "experimental",
    "content": "현재 Experimental 단계에 있는 API:"
  }, {
    "heading": "experimental",
    "content": "turbo query"
  }, {
    "heading": "experimental",
    "content": "turbo boundaries 및 Tags"
  }, {
    "heading": "experimental",
    "content": "turbo watch용 --experimental-write-cache"
  }, {
    "heading": "experimental",
    "content": "turbo ls --affected 플래그용 --output=json"
  }, {
    "heading": "deprecated",
    "content": "Deprecated API는 제거 중입니다. 제거할 예정인 모든 기능에는 다음 단계와 기능이 제거될 것으로 예상되는 시기에 대한 정보가 포함된 기존 사용자를 위한 문서가 포함됩니다."
  }, {
    "heading": "deprecated",
    "content": "현재 deprecated된 API:"
  }, {
    "heading": "deprecated",
    "content": "TURBO_REMOTE_ONLY 및 --remote-only: TURBO_CACHE 또는 --cache 사용"
  }],
  "headings": [{
    "id": "패키지-관리자",
    "content": "패키지 관리자"
  }, {
    "id": "플랫폼",
    "content": "플랫폼"
  }, {
    "id": "nodejs",
    "content": "Node.js"
  }, {
    "id": "버전-관리",
    "content": "버전 관리"
  }, {
    "id": "lts-정책",
    "content": "LTS 정책"
  }, {
    "id": "릴리스-단계",
    "content": "릴리스 단계"
  }, {
    "id": "stable",
    "content": "Stable"
  }, {
    "id": "beta",
    "content": "Beta"
  }, {
    "id": "experimental",
    "content": "Experimental"
  }, {
    "id": "deprecated",
    "content": "Deprecated"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#패키지-관리자",
  title: _jsx(_Fragment, {
    children: "패키지 관리자"
  })
}, {
  depth: 2,
  url: "#플랫폼",
  title: _jsx(_Fragment, {
    children: "플랫폼"
  })
}, {
  depth: 2,
  url: "#nodejs",
  title: _jsx(_Fragment, {
    children: "Node.js"
  })
}, {
  depth: 2,
  url: "#버전-관리",
  title: _jsx(_Fragment, {
    children: "버전 관리"
  })
}, {
  depth: 2,
  url: "#lts-정책",
  title: _jsx(_Fragment, {
    children: "LTS 정책"
  })
}, {
  depth: 2,
  url: "#릴리스-단계",
  title: _jsx(_Fragment, {
    children: "릴리스 단계"
  })
}, {
  depth: 3,
  url: "#stable",
  title: _jsx(_Fragment, {
    children: "Stable"
  })
}, {
  depth: 3,
  url: "#beta",
  title: _jsx(_Fragment, {
    children: "Beta"
  })
}, {
  depth: 3,
  url: "#experimental",
  title: _jsx(_Fragment, {
    children: "Experimental"
  })
}, {
  depth: 3,
  url: "#deprecated",
  title: _jsx(_Fragment, {
    children: "Deprecated"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "패키지-관리자",
      children: "패키지 관리자"
    }), "\n", _jsxs(_components.p, {
      children: ["핵심 ", _jsx(_components.code, {
        children: "turbo"
      }), " 기능은 JavaScript 생태계의 패키지 관리자와 해당 Workspace 및 lockfile 형식 구현에 의존합니다."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "패키지 관리자"
          }), _jsx(_components.th, {
            children: "지원 여부"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "pnpm 8+"
          }), _jsx(_components.td, {
            children: "예"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "npm 8+"
          }), _jsx(_components.td, {
            children: "예"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "yarn 1+"
          }), _jsx(_components.td, {
            children: "예 (Yarn Plug'n'Play 포함)"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "bun 1.2+"
          }), _jsx(_components.td, {
            children: "Beta"
          })]
        })]
      })]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "패키지 관리자는 자체 릴리스 일정, 버그 및 기능을 가지고 있습니다. 새로운 주요\n버전을 따라가려고 노력하지만 즉시 지원을 릴리스하지 못할 가능성이 높습니다."
      })
    }), "\n", _jsx(_components.h2, {
      id: "플랫폼",
      children: "플랫폼"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 일반적으로 Debian 기반 Linux 배포판, macOS 및 Windows에서 x86_64 및 ARM 64 아키텍처 모두에서 지원됩니다. 구체적으로, npm을 통해 다음 바이너리를 빌드하고 제공합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo-darwin-64"
        }), " (Intel 칩을 사용하는 macOS)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo-darwin-arm64"
        }), " (Apple Silicon을 사용하는 macOS)"]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "turbo-linux-64"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "turbo-linux-arm64"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo-windows-64"
        }), "*"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo-windows-arm64"
        }), "*"]
      }), "\n"]
    }), "\n", _jsx("small", {
      children: _jsxs(_components.p, {
        children: ["*: ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/cpp/windows/latest-supported-vc-redist",
          children: "Windows C Runtime\nLibraries"
        }), "\n필요"]
      })
    }), "\n", _jsx(_components.h2, {
      id: "nodejs",
      children: "Node.js"
    }), "\n", _jsxs(_components.p, {
      children: ["핵심 ", _jsx(_components.code, {
        children: "turbo"
      }), " 기능은 시스템의 활성 Node.js 버전에 의존하지 않지만, ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: _jsx(_components.code, {
          children: "turbo-ignore"
        })
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: _jsx(_components.code, {
          children: "eslint-config-turbo"
        })
      }), "와 같은 ", _jsx(_components.a, {
        href: "/docs/reference#packages",
        children: "Turborepo 생태계의 일부 패키지"
      }), "는 의존합니다. 이러한 기능의 경우 ", _jsx(_components.a, {
        href: "https://nodejs.org/en/about/previous-releases",
        children: "Node.js의 Active 및 Maintenance LTS 버전"
      }), "을 지원할 예정입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "예제"
      }), "도 이러한 Node.js 버전에서 작동할 것으로 예상됩니다."]
    }), "\n", _jsx(_components.h2, {
      id: "버전-관리",
      children: "버전 관리"
    }), "\n", _jsx(_components.p, {
      children: "Git으로 버전 관리되는 리포지토리와 버전 관리가 전혀 없는 리포지토리를 지원합니다. 다른 버전 관리 시스템은 무시됩니다."
    }), "\n", _jsx(_components.p, {
      children: "파일 해싱에 Git을 사용하므로 git이 없는 리포지토리는 다르게 수행되고 동작할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "lts-정책",
      children: "LTS 정책"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 주요 버전은 다음 주요 버전의 릴리스 날짜로부터 2년 동안 지원됩니다."
    }), "\n", _jsx(_components.p, {
      children: "이전 버전의 중요한 보안 수정에 필요한 변경 사항은 백포트됩니다. 이러한 상황은 드물며 중대한 변경 사항이더라도 semver-minor 릴리스로 제공됩니다."
    }), "\n", _jsx(_components.p, {
      children: "가능한 한 최신 버전의 Turborepo를 사용하실 것을 강력히 권장합니다."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "주요 버전"
          }), _jsx(_components.th, {
            children: "릴리스 날짜"
          }), _jsx(_components.th, {
            children: "지원 종료 날짜"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "2.x"
          }), _jsx(_components.td, {
            children: "2024년 6월 4일"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "1.x"
          }), _jsx(_components.td, {
            children: "2021년 12월 9일"
          }), _jsx(_components.td, {
            children: "2026년 6월 4일"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "릴리스-단계",
      children: "릴리스 단계"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 안정 빌드는 시맨틱 버저닝(semver)을 따르며 릴리스되기 전에 철저하게 테스트됩니다."
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 또한 개발의 초기 단계에서 릴리스될 수 있는 특정 API를 제공합니다. 이는 얼리 어답터가 귀중한 피드백을 제공하고 핵심 팀이 안정적인 릴리스 전에 API에 대한 확신을 얻을 수 있도록 하기 위한 것입니다. 사전 안정 버전으로 제공되는 API는 가능한 한 문서와 ", _jsx(_components.code, {
        children: "turbo"
      }), " 자체에서 그렇게 표시됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "모든 API가 모든 단계에서 릴리스되는 것은 아닙니다. 기능의 복잡성, 가능한 사용 사례 및 API의 초기 사용자로부터의 피드백과 같은 요소를 고려하여 기능에 대한 확신을 바탕으로 API의 단계를 결정하기 위해 최선의 판단을 사용합니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 핵심 팀은 기능을 조기에 사용하는 모든 사용자에게 감사드리며 제공해주시는 모든 피드백에 대해 감사를 표합니다."
    }), "\n", _jsx(_components.h3, {
      id: "stable",
      children: "Stable"
    }), "\n", _jsx(_components.p, {
      children: "API가 안정성에 도달하면 프로덕션에서 사용할 준비가 된 것으로 간주됩니다. 안정 버전으로 표시된 API는 주요 릴리스에서만 하위 호환되는 방식으로 변경됩니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["안정적인 API가 향후 주요 릴리스에서 ", _jsx(_components.strong, {
          children: "중대한 변경 사항"
        }), "을 가질 예정인 경우, 마이그레이션 및 다음 단계를 돕기 위한 경고 및 문서가 제공됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["안정적인 API가 향후 주요 릴리스에서 ", _jsx(_components.strong, {
          children: "제거"
        }), "될 예정인 경우, 향후 제거에 대한 조기 통지를 제공하기 위해 ", _jsx(_components.a, {
          href: "#deprecated",
          children: "Deprecated"
        }), "로 표시됩니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "beta",
      children: "Beta"
    }), "\n", _jsx(_components.p, {
      children: "Beta API는 안정적인 릴리스 전에 신뢰성에 대한 더 많은 확신이 필요합니다. Beta 단계에서는 기능의 전체 디자인에 대해 확신하고 있으며 상대적으로 적은 변경으로 기능을 안정 버전으로 승격할 수 있을 것으로 예상합니다. 드문 경우지만 API가 중대한 변경을 필요로 할 수 있으며 semver의 적용을 받지 않습니다."
    }), "\n", _jsx(_components.p, {
      children: "얼리 어답터가 Beta API를 사용하여 기능의 디자인과 안정성에 대한 확신을 얻도록 권장합니다. 위험 허용 범위에 따라 적절하게 프로덕션에서 기능을 사용할 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "현재 Beta 단계에 있는 API:"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "없음"
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "experimental",
      children: "Experimental"
    }), "\n", _jsx(_components.p, {
      children: "Experimental API는 안정성을 위해 필요한 필수 기능이 부족합니다. 기능의 디자인은 활발하게 개발 중인 것으로 간주되며 언제든지 변경될 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "안정성이 필수적이지 않은 사이드 프로젝트, 개념 증명 및 기타 환경에서 Experimental API를 테스트하는 데 도움을 주시길 권장합니다. 이를 통해 기능이 개발되는 동안 핵심 팀에 조기 피드백을 제공함으로써 API 개발을 지원할 수 있는 기회를 얻을 수 있습니다. 신뢰성이 필수적인 곳에서는 Experimental API를 사용하지 않는 것이 좋습니다."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "현재 Experimental 단계에 있는 API:"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/query",
          children: _jsx(_components.code, {
            children: "turbo query"
          })
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/reference/boundaries",
          children: _jsx(_components.code, {
            children: "turbo boundaries"
          })
        }), " 및 ", _jsx(_components.a, {
          href: "/docs/reference/boundaries#tags",
          children: "Tags"
        })]
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "/docs/reference/watch#caching",
          children: [_jsx(_components.code, {
            children: "turbo watch"
          }), "용 ", _jsx(_components.code, {
            children: "--experimental-write-cache"
          })]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "/docs/reference/ls",
          children: [_jsx(_components.code, {
            children: "turbo ls --affected"
          }), " 플래그용 ", _jsx(_components.code, {
            children: "--output=json"
          })]
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "deprecated",
      children: "Deprecated"
    }), "\n", _jsx(_components.p, {
      children: "Deprecated API는 제거 중입니다. 제거할 예정인 모든 기능에는 다음 단계와 기능이 제거될 것으로 예상되는 시기에 대한 정보가 포함된 기존 사용자를 위한 문서가 포함됩니다."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "현재 deprecated된 API:"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_REMOTE_ONLY"
        }), " 및 ", _jsx(_components.code, {
          children: "--remote-only"
        }), ": ", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_CACHE"
          })
        }), " 또는 ", _jsx(_components.a, {
          href: "/docs/reference/run#--cache-options",
          children: "--cache"
        }), " 사용"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
